import { configManager } from '../configuration';
import { ABTestingConfigItem } from './abTestCookieHelper.types';
import { TFlagTypes } from '../../types/flags';

export function setABTestCookieValue(
  tempCookieStr: string,
  cookieKey: string
): string {
  let cookieStr = tempCookieStr;
  const randomVal = Math.floor(Math.random() * 101);
  if (cookieStr && cookieStr.indexOf(cookieKey) < 0) {
    cookieStr = `${cookieStr}-${cookieKey}_${randomVal}`;
  } else if (!cookieStr) {
    cookieStr = `${cookieKey}_${randomVal}`;
  }
  return cookieStr;
}

export function getABTestCookieValue(
  cookieStr: string,
  cookieKey: string
): number | undefined {
  if (cookieStr) {
    const abTestingCookieValue = cookieStr
      .split('-')
      .find((item) => item.charAt(0) === cookieKey);
    if (abTestingCookieValue) {
      return parseInt(abTestingCookieValue.substring(2), 10);
    }
  }
  return undefined;
}

export function getPeriodsOfCookieItem(
  abTestCookieValue: string
):
  | { ASIS: { min: number; max: number }; NEW: { min: number; max: number } }
  | Record<string, never> {
  const periods = abTestCookieValue.split('|')[1].split(':');
  return periods.reduce((previousValue, currentValue) => {
    const asisNewValues = currentValue.split('_');
    const [min, max] = asisNewValues[1].split('-');
    return {
      ...previousValue,
      [asisNewValues[0]]: {
        min: parseInt(min, 10),
        max: parseInt(max, 10),
      },
    };
  }, {});
}

export function isCookieValueASIS(
  cookieStr: string,
  configValue: string
): boolean | undefined {
  const cookieKey = configValue.substring(0, configValue.indexOf('|'));
  const cookieValue = getABTestCookieValue(cookieStr, cookieKey);
  if (cookieValue) {
    const periods = getPeriodsOfCookieItem(configValue);
    return (
      periods.ASIS &&
      cookieValue >= periods.ASIS.min &&
      cookieValue <= periods.ASIS.max
    );
  }
  return undefined;
}

export function isCookieValueNEW(
  cookieStr: string,
  configValue: string
): boolean {
  const cookieKey = configValue.substring(0, configValue.indexOf('|'));
  const cookieValue = getABTestCookieValue(cookieStr, cookieKey);
  if (cookieValue) {
    const periods = getPeriodsOfCookieItem(configValue);
    return (
      periods.NEW &&
      cookieValue >= periods.NEW.min &&
      cookieValue <= periods.NEW.max
    );
  }
  return false;
}

export function createAllABTestCookiesForUser(
  currentCookieStr: string,
  abTestingCookieValues: []
): string {
  let cookieStr = currentCookieStr;
  abTestingCookieValues.forEach((cookieItem: Record<string, string>) => {
    const cookieKey = cookieItem.testKey.substring(
      0,
      cookieItem.testKey.indexOf('|')
    );
    cookieStr = setABTestCookieValue(cookieStr, cookieKey);
  });
  return cookieStr;
}

export function isNewFeatureForABTesting(
  userFlags: Partial<TFlagTypes>,
  testName: string
): boolean {
  const config = configManager.getInstance().get;
  const abTestingConfigVariables = config(
    'AB_TESTING_VARIABLES'
  ) as ABTestingConfigItem[];
  const raffleListingConfig = abTestingConfigVariables.find(
    (cookieVal) => cookieVal.testName === testName
  );
  return isCookieValueNEW(
    userFlags.abTestingValues as string,
    raffleListingConfig?.testKey || ''
  );
}
